var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpathyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2697 9.80871C23.443 6.9261 19.643 5.30871 15.5764 5.21741C15.4697 5.21741 15.363 5.21741 15.2564 5.21741C11.2964 5.21741 7.56303 6.69132 4.69636 9.37827C1.74969 12.1435 0.0963628 15.8609 0.00302951 19.8391C-0.0769705 23.8305 1.42969 27.6 4.25636 30.4826L7.12302 33.3783L29.0964 12.6652L26.2697 9.80871Z",
    fill: "#0C233C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8431 26.4261L39.4698 5.7522L32.0698 12.7174L30.5631 14.1392L8.61646 34.8392L27.7898 54.3L28.9898 55.5131L50.9631 34.8L52.4831 33.3783L59.8431 26.4261Z",
    fill: "#0C233C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpathyIcon);
export default __webpack_public_path__ + "static/media/EmpathyIcon.14e3c504295eab51271256bb709c9651.svg";
export { ForwardRef as ReactComponent };